import '../styles/main.report.scss'
import { replaceReducers } from '@/store'
import context from '../context'
context.config = require('./config')
context.menuContent = require('./menu-content').default
context.reducers = require('./reducers').default
context.widgets = require('./widgets').default
context.defaultLayout = require('@/layouts/Default').default
context.routes = require('./routes').default
context.api = require('./api').default
context.authCheck = user => !!(user && user.access_token && !user.expired)
context.menu = require('./menu').default
context.dialogs = require('./dialogs').default
context.initializer = require('./initializer').default
context.cache = require('./cached').default

// Enable Webpack hot module replacement for reducers
if (module.hot) {
  module.hot.accept('./reducers', () => {
    context.reducers = require('./reducers').default
    replaceReducers(context.reducers)
  })
}



// WEBPACK FOOTER //
// ./src/report-app/index.js